import { PASSWORD_MIN_CHARS } from '@rp/contracts'

export const MEMBER_PASSWORD_COPY = {
  label: '初始密碼',
  hint: `最少 ${PASSWORD_MIN_CHARS} 個字元。對方第一次登入後必須先改成自己的密碼。`,
  generate: '隨機產生',
  required: '請設定初始密碼，或按「隨機產生」。',
  tooShort: `密碼最少要 ${PASSWORD_MIN_CHARS} 個字元`,
  inviteWithout: '不設密碼，直接邀請',
  revealTitle: (email: string) => `${email} 的臨時密碼`,
  revealNote: '這個密碼只會顯示這一次，關閉後不會再顯示。請把它交給對方；對方第一次登入時必須先更改密碼。',
  copy: '複製密碼',
  copied: '已複製',
  copyFailed: '未能複製，請手動選取密碼。',
  dismiss: '我已記下，關閉',
  reset: '重設密碼',
  resetTitle: '重設密碼',
  resetBody: (email: string) =>
    `會替 ${email} 設定一個新的臨時密碼。對方原本的密碼會即時失效，下次登入時必須先改成自己的密碼。只有由管理員建立、而且只屬於這個工作區的帳號才可以重設。`,
  resetConfirm: '確認重設',
  resetting: '重設中…',
} as const
